const stripProtocol = (value: string) => value.replace(/^https?:\/\//, '').toLowerCase();

const resolveSupabaseAuthHost = () => {
  const envHost = import.meta.env.VITE_SUPABASE_AUTH_DOMAIN;
  if (envHost && !envHost.includes('%VITE')) {
    return stripProtocol(envHost);
  }
  return 'auth.getvitly.com';
};

const supabaseAuthHost = resolveSupabaseAuthHost();

export const isSupabaseAuthDomain = (): boolean => {
  if (typeof window === 'undefined') {
    return false;
  }
  return window.location.hostname.toLowerCase() === supabaseAuthHost;
};

export const getSupabaseAuthHost = () => supabaseAuthHost;
